module.exports = __webpack_public_path__ + "static/media/poster_bg.42913d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/InvitePoster/img/poster_bg.png
// module id = 684
// module chunks = 1